module.exports = __webpack_public_path__ + "img/peopleFrame.2ae62902.png";